(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["price-filter"] && !Shopify.designMode) return;
  try {
    function initPriceSlider(scope = document) {
  const rangeMin = scope.querySelector('#range-min');
  const rangeMax = scope.querySelector('#range-max');
  const inputMin = scope.querySelector('#Price-Min');
  const inputMax = scope.querySelector('#Price-Max');
  const track = scope.querySelector('.slider-track');

  if (!rangeMin || !rangeMax || !inputMin || !inputMax || !track) return;

  // Skip if already initialized
  if (rangeMin.dataset.sliderInit) return;
  rangeMin.dataset.sliderInit = 'true';

  const minGap = 1;
  const rangeMaxValue = parseFloat(rangeMax.max);

  function updateTrack() {
    const percent1 = (rangeMin.value / rangeMaxValue) * 100;
    const percent2 = (rangeMax.value / rangeMaxValue) * 100;
    track.style.left = percent1 + '%';
    track.style.right = (100 - percent2) + '%';
  }

  // Range → Inputs
  rangeMin.addEventListener('input', () => {
    if (parseFloat(rangeMax.value) - parseFloat(rangeMin.value) <= minGap) {
      rangeMin.value = parseFloat(rangeMax.value) - minGap;
    }
    inputMin.value = rangeMin.value;
    inputMin.dispatchEvent(new Event('change'));
    updateTrack();
  });

  rangeMax.addEventListener('input', () => {
    if (parseFloat(rangeMax.value) - parseFloat(rangeMin.value) <= minGap) {
      rangeMax.value = parseFloat(rangeMin.value) + minGap;
    }
    inputMax.value = rangeMax.value;
    inputMax.dispatchEvent(new Event('change'));
    updateTrack();
  });

  // Inputs → Range
  inputMin.addEventListener('input', () => {
    rangeMin.value = inputMin.value;
    updateTrack();
  });

  inputMax.addEventListener('input', () => {
    rangeMax.value = inputMax.value;
    updateTrack();
  });

  updateTrack();
}

// Update track position for all sliders (call after AJAX updates)
function updateAllPriceSliderTracks() {
  document.querySelectorAll('.range-slider').forEach(slider => {
    const rangeMin = slider.querySelector('#range-min');
    const rangeMax = slider.querySelector('#range-max');
    const track = slider.querySelector('.slider-track');
    
    if (!rangeMin || !rangeMax || !track) return;
    
    const rangeMaxValue = parseFloat(rangeMax.max);
    const percent1 = (rangeMin.value / rangeMaxValue) * 100;
    const percent2 = (rangeMax.value / rangeMaxValue) * 100;
    track.style.left = percent1 + '%';
    track.style.right = (100 - percent2) + '%';
  });
}

document.addEventListener('DOMContentLoaded', () => {
  // Initialize on page load
  initPriceSlider();
  
  // Watch for DOM changes (filter updates via AJAX)
  const observer = new MutationObserver((mutations) => {
    let shouldUpdate = false;
    
    for (const mutation of mutations) {
      // Check if new nodes include range-slider
      if (mutation.addedNodes.length) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType === 1) {
            if (node.classList?.contains('range-slider') || node.querySelector?.('.range-slider')) {
              shouldUpdate = true;
              break;
            }
          }
        }
      }
    }
    
    if (shouldUpdate) {
      // Re-initialize sliders after DOM update
      setTimeout(() => {
        initPriceSlider();
        updateAllPriceSliderTracks();
      }, 50);
    }
    
    // Also check for mobile drawer
    const dialog = document.querySelector('dialog.facets--drawer[open]');
    if (dialog) {
      initPriceSlider(dialog);
      updateAllPriceSliderTracks();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['open']
  });
});
  } catch(e) { console.error(e); }
})();

})();
